/* TODO: url encode these values, current usage is fine, but it really should be encoded */
export const toQueryString = (queryParams: {}): string => Object.keys(queryParams).map(key => `${key}=${queryParams[key]}`).join('&');